import Swiper from './vendor/swiper-bundle.min';
import { Fancybox } from './vendor/fancybox.umd';
import reviewSliderOptions from '../blocks/review-slider/slider-options';

jQuery( document ).ready( function ( $ ) {
	Fancybox.bind( '[data-fancybox]', {} );

	$( '.js-submenu-toggle' ).on( 'click', function () {
		$( this ).next( '.sub-menu' ).slideToggle();
		$( this ).closest( 'li' ).toggleClass( 'is-open' );
	} );

	$( '.js-mobile-menu-trigger' ).on( 'click', function () {
		$( '.header' ).toggleClass( 'is-mobile-menu-open' );
		$( '.header__main' ).removeClass( 'is-background has-overlay' );
	} );

	if ( $( this ).scrollTop() > 0 ) {
		$( '.header__main' )
			.removeClass( 'is-hidden' )
			.addClass( 'has-overlay' );
	}

	let lastScrollTop = 0;
	const headerHeight = $( '.header__top' ).outerHeight();
	$( window ).on( 'scroll', function () {
		const scrollTop = $( this ).scrollTop();
		if ( scrollTop > lastScrollTop && scrollTop > headerHeight ) {
			$( '.header__main' )
				.addClass( 'is-hidden' )
				.removeClass( 'has-overlay' );
		} else if ( scrollTop > headerHeight ) {
			$( '.header__main' )
				.removeClass( 'is-hidden' )
				.addClass( 'has-overlay' );
		} else {
			$( '.header__main' )
				.removeClass( 'is-hidden' )
				.removeClass( 'has-overlay' );
		}
		lastScrollTop = scrollTop;
	} );

	$( '.mobile-menu__block' ).scroll( function () {
		const scrollTop = $( this ).scrollTop();
		const windowWidth = $( this ).width();
		if ( windowWidth < 992 ) {
			if ( scrollTop > 10 ) {
				$( '.header__main' ).addClass( 'is-background' );
			} else {
				$( '.header__main' ).removeClass( 'is-background' );
			}
		}
	} );

	const products = document.querySelector( '.js-trader-products' );
	if ( products ) {
		new Swiper( '.js-trader-products', {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 30,
			speed: 1000,
			navigation: {
				nextEl: '.wp-block-trader-products .swiper-button-next',
				prevEl: '.wp-block-trader-products .swiper-button-prev',
			},
			breakpoints: {
				768: { slidesPerView: 2, spaceBetween: 40 },
				1199: { slidesPerView: 3, spaceBetween: 40 },
			},
		} );
	}

	const reviews = document.querySelector( '.js-trader-reviews' );
	if ( reviews ) {
		new Swiper( '.js-trader-reviews', {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 30,
			speed: 1000,
			navigation: {
				nextEl: '.wp-block-trader-reviews .swiper-button-next',
				prevEl: '.wp-block-trader-reviews .swiper-button-prev',
			},
			pagination: {
				el: '.js-trader-reviews .swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				768: { slidesPerView: 2, spaceBetween: 40 },
				992: { slidesPerView: 2.5, spaceBetween: 40 },
				1440: { slidesPerView: 3.58, spaceBetween: 40 },
				1921: { slidesPerView: 4.3, spaceBetween: 40 },
			},
		} );
	}

	// trader/review-slider (settings shared with the editor preview).
	document.querySelectorAll( '.js-reviews-slider' ).forEach( ( slider ) => {
		new Swiper( slider, reviewSliderOptions( slider ) );
	} );

	const readCarouselOverlap = ( el ) => {
		const overlap = parseFloat(
			window
				.getComputedStyle( el )
				.getPropertyValue( '--carousel-overlap' )
		);
		return Number.isFinite( overlap ) ? -overlap : 0;
	};

	const eachCarouselSlide = ( instance, callback ) => {
		instance.slides.forEach( ( slide ) => {
			const inner = slide.querySelector( '.carousel-slide' );

			if ( inner ) {
				callback( inner, slide );
			}
		} );
	};

	const setSlideProgress = ( instance ) => {
		eachCarouselSlide( instance, ( inner, slide ) => {
			const progress = Number.isFinite( slide.progress )
				? Math.min( Math.abs( slide.progress ), 2 )
				: 0;

			inner.style.setProperty(
				'--slide-progress',
				progress.toFixed( 3 )
			);
		} );
	};

	const setSlideTransition = ( instance, duration ) => {
		eachCarouselSlide( instance, ( inner ) => {
			inner.style.setProperty(
				'--carousel-slide-duration',
				`${ duration }ms`
			);
		} );
	};

	const ensureLoopableSlides = ( el ) => {
		const wrapper = el.querySelector( '.swiper-wrapper' );
		const originalSlides = wrapper ? Array.from( wrapper.children ) : [];
		const originalCount = originalSlides.length;

		if ( originalCount < 2 || ! originalSlides[ 0 ] ) {
			return originalCount;
		}

		const slideWidth = originalSlides[ 0 ].getBoundingClientRect().width;
		const visible = slideWidth
			? Math.max( 1, Math.ceil( el.clientWidth / slideWidth ) )
			: 3;
		const required = visible * 3;

		if ( originalCount >= required ) {
			return originalCount;
		}

		const times = Math.max( 1, Math.ceil( required / originalCount ) );

		for ( let t = 1; t < times; t += 1 ) {
			originalSlides.forEach( ( slide ) => {
				wrapper.appendChild( slide.cloneNode( true ) );
			} );
		}

		return originalCount;
	};

	const buildPagination = ( swiper, paginationEl, originalCount ) => {
		if ( ! paginationEl ) {
			return;
		}

		paginationEl.innerHTML = '';
		const bullets = [];

		const syncActive = () => {
			const active = swiper.realIndex % originalCount;
			bullets.forEach( ( bullet, i ) => {
				bullet.classList.toggle(
					'swiper-pagination-bullet-active',
					i === active
				);
			} );
		};

		for ( let i = 0; i < originalCount; i += 1 ) {
			const bullet = document.createElement( 'span' );
			bullet.className = 'swiper-pagination-bullet';
			bullet.setAttribute( 'role', 'button' );
			bullet.setAttribute( 'tabindex', '0' );
			bullet.setAttribute( 'aria-label', `Go to slide ${ i + 1 }` );
			bullet.addEventListener( 'click', () => {
				const current = swiper.activeIndex;
				let target = null;
				let shortest = Infinity;

				swiper.slides.forEach( ( slideEl, pos ) => {
					const dataIndex = parseInt(
						slideEl.getAttribute( 'data-swiper-slide-index' ),
						10
					);

					if (
						Number.isNaN( dataIndex ) ||
						dataIndex % originalCount !== i
					) {
						return;
					}

					const diff = Math.abs( pos - current );
					const distance = Math.min(
						diff,
						swiper.slides.length - diff
					);

					if ( distance < shortest ) {
						shortest = distance;
						target = pos;
					}
				} );

				if ( target === null ) {
					return;
				}

				swiper.slideTo( target );
			} );
			paginationEl.appendChild( bullet );
			bullets.push( bullet );
		}

		swiper.on( 'transitionEnd', () => {
			swiper.loopFix();
			syncActive();
		} );
		swiper.on( 'realIndexChange', syncActive );
		swiper.on( 'loopFix', syncActive );
		syncActive();
	};

	const prefersReducedMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	document.querySelectorAll( '.js-trader-carousel' ).forEach( ( el ) => {
		if ( el.swiper ) {
			return;
		}

		let options = {};
		try {
			options = JSON.parse( el.dataset.carousel || '{}' );
		} catch {
			options = {};
		}

		const root = el.closest( '.carousel' );
		const section = el.closest( '.wp-block-trader-carousel' );
		const nextEl = root && root.querySelector( '.swiper-button-next' );
		const prevEl = root && root.querySelector( '.swiper-button-prev' );
		const paginationEl = root && root.querySelector( '.swiper-pagination' );

		const autoplayOn = !! options.autoplay && ! prefersReducedMotion;
		const originalCount = ensureLoopableSlides( el );
		const looping = !! options.loop && originalCount > 1;

		let inView = true;
		let held = false;

		const swiper = new Swiper( el, {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: readCarouselOverlap( el ),
			speed: 700,
			grabCursor: true,
			watchSlidesProgress: true,
			...( looping ? { loop: true } : { rewind: true } ),
			...( autoplayOn
				? {
						autoplay: {
							delay: options.autoplayDelay || 5000,
							disableOnInteraction: false,
							pauseOnMouseEnter: true,
						},
				  }
				: {} ),
			...( nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {} ),
			on: {
				beforeResize( instance ) {
					instance.params.spaceBetween = readCarouselOverlap( el );
				},
				progress( instance ) {
					setSlideProgress( instance );
				},
				setTransition( instance, duration ) {
					setSlideTransition(
						instance,
						prefersReducedMotion ? 0 : duration
					);
				},
			},
		} );

		const syncAutoplay = () => {
			if ( ! autoplayOn || ! swiper.autoplay ) {
				return;
			}

			if ( inView && ! held ) {
				swiper.autoplay.start();
			} else {
				swiper.autoplay.stop();
			}
		};

		buildPagination( swiper, paginationEl, originalCount );

		syncAutoplay();

		if ( root ) {
			const hold = () => {
				held = true;
				syncAutoplay();
			};

			const release = ( event ) => {
				if ( event && root.contains( event.relatedTarget ) ) {
					return;
				}
				held = false;
				syncAutoplay();
			};

			root.addEventListener( 'mouseenter', hold );
			root.addEventListener( 'mouseleave', release );
			root.addEventListener( 'focusin', hold );
			root.addEventListener( 'focusout', release );
		}

		if ( section && 'IntersectionObserver' in window ) {
			inView = false;
			new window.IntersectionObserver(
				( entries ) => {
					entries.forEach( ( entry ) => {
						inView = entry.isIntersecting;
					} );
					syncAutoplay();
				},
				{ threshold: 0.2 }
			).observe( section );
			syncAutoplay();
		}
	} );
	const faqItems = $( '.js-faq-item' );
	if ( faqItems.length ) {
		$( '.js-faq-item' ).each( function () {
			$( this ).on( 'click', function () {
				$( this ).toggleClass( 'is-open' );
				$( this ).next( '.faq-content' ).slideToggle();
			} );
		} );
	}

	const faqCategoryButtons = $( '.js-faq-category-button' );
	if ( faqCategoryButtons.length ) {
		faqCategoryButtons.on( 'click', function () {
			const $group = $( this ).closest( '.wp-block-trader-faq' );
			const categoryId = $( this ).data( 'category-id' );

			$group.find( '.js-faq-category-button' ).removeClass( 'is-active' );
			$( this ).addClass( 'is-active' );

			const $faqItems = $group.find( '.faq-item' );

			if ( `${ categoryId }` === '0' ) {
				$faqItems.show();
			} else {
				$faqItems
					.hide()
					.filter( function () {
						const itemCategories = (
							$( this ).data( 'category' ) || ''
						)
							.toString()
							.split( ' ' );
						return itemCategories.includes( `${ categoryId }` );
					} )
					.show();
			}
		} );
	}

	const tickerSpeed = 0.5;
	let flickity = null;
	let isPaused = false;
	const slideshowEl = document.querySelector( '.js-slideshow' );

	if ( slideshowEl && window.Flickity ) {
		// eslint-disable-next-line no-undef
		const update = () => {
			if ( isPaused ) {
				return;
			}
			if ( flickity.slides ) {
				flickity.x =
					( flickity.x - tickerSpeed ) % flickity.slideableWidth;
				flickity.selectedIndex = flickity.dragEndRestingSelect();
				flickity.updateSelectedSlide();
				flickity.settle( flickity.x );
			}
			window.requestAnimationFrame( update );
		};

		const pause = () => {
			isPaused = true;
		};
		const play = () => {
			if ( isPaused ) {
				isPaused = false;
				window.requestAnimationFrame( update );
			}
		};

		flickity = new window.Flickity( slideshowEl, {
			autoPlay: false,
			prevNextButtons: false,
			pageDots: false,
			draggable: true,
			wrapAround: true,
			selectedAttraction: 0.015,
			friction: 0.25,
		} );
		flickity.x = 0;

		slideshowEl.addEventListener( 'mouseenter', pause, false );
		slideshowEl.addEventListener( 'focusin', pause, false );
		slideshowEl.addEventListener( 'mouseleave', play, false );
		slideshowEl.addEventListener( 'focusout', play, false );
		flickity.on( 'dragStart', () => {
			isPaused = true;
		} );
		update();
	}

	if ( $( window ).width() < 769 ) {
		$( '.footer__top .wp-block-heading' ).on( 'click', function () {
			$( this )
				.closest( '.widget-area' )
				.find( '.widget_nav_menu' )
				.slideToggle();
			$( this )
				.closest( '.widget-area' )
				.find( '.footer-contacts' )
				.slideToggle();
		} );
	}

	$( window ).resize( function () {
		if ( $( window ).width() < 991 ) {
			$( '.footer__top .wp-block-heading' )
				.off( 'click' )
				.on( 'click', function () {
					$( this )
						.closest( '.widget-area' )
						.find( '.widget_nav_menu' )
						.slideToggle();
					$( this )
						.closest( '.widget-area' )
						.find( '.footer-contacts' )
						.slideToggle();
				} );
		} else {
			$( '.footer__top .wp-block-heading' ).off( 'click' );
		}
	} );

	$( '.is-modal-window a' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( 'a#modal-form-trigger' ).trigger( 'click' );
	} );

	$( ".wp-element-button[href^='#cta-modal-window']" ).on(
		'click',
		function ( e ) {
			e.preventDefault();
			document.querySelector( '#modal-form-trigger' ).click();
		}
	);
} );

let latestStories, latestStories2;
function initializeSwiper() {
	if ( ! latestStories && window.innerWidth < 992 ) {
		latestStories = new Swiper( '.js-latest-stories', {
			loop: true,
			slidesPerView: 1.25,
			spaceBetween: 20,
			pagination: {
				el: '.js-latest-stories .swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				520: { slidesPerView: 1.5 },
				650: { slidesPerView: 2.25 },
				780: { slidesPerView: 2.5 },
			},
		} );
	} else if ( latestStories && window.innerWidth >= 992 ) {
		latestStories.destroy( true, true );
		latestStories = undefined;
	}

	if ( ! latestStories2 && window.innerWidth < 992 ) {
		latestStories2 = new Swiper( '.js-latest-stories-2', {
			loop: true,
			slidesPerView: 1.25,
			spaceBetween: 20,
			pagination: {
				el: '.js-latest-stories-2 .swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				520: { slidesPerView: 1.5 },
				650: { slidesPerView: 2.25 },
				780: { slidesPerView: 2.5 },
			},
		} );
	} else if ( latestStories2 && window.innerWidth >= 992 ) {
		latestStories2.destroy( true, true );
		latestStories2 = undefined;
	}
}

document.addEventListener( 'DOMContentLoaded', initializeSwiper );
window.addEventListener( 'resize', initializeSwiper );
